import { Box, Typography, Stack } from "@mui/material";
import { useTranslation } from "react-i18next";
import emailOutlinedIcon from "../../../../../assets/images/SVG/emailOutlinedIcon.svg";
import RoundedButton from "../../../../../components/Buttons/RoundedButton/RoundedButton";

const SelfInviteBlockedView = ({ redirectToDashboard, onGenerateNewLink }) => {
  const { t } = useTranslation();
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        width: "100%",
      }}
    >
      <Typography
        variant="h5"
        sx={{
          color: "#662D91",
          textAlign: "center",
          fontWeight: 700,
          fontStyle: "normal",
          fontFamily: "Montserrat, sans-serif",
          fontSize: "1.125rem",
          lineHeight: "1.339rem",
          letterSpacing: "0%",
          mb: 4,
        }}
      >
        {t("inviteUsers.self_invite_blocked_title")}
      </Typography>

      <Typography
        variant="body1"
        sx={{
          fontFamily: "Montserrat, sans-serif",
          fontWeight: 400,
          fontStyle: "normal",
          fontSize: "0.938rem",
          lineHeight: "0.969rem",
          letterSpacing: "0%",
          textAlign: "center",
          color: "#4d4d4d",
          mb: 3,
          maxWidth: 480,
        }}
      >
        {t("inviteUsers.self_invite_blocked_description")}
      </Typography>

      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          gap: 2,
          backgroundColor: "rgba(102, 45, 145, 0.08)",
          border: "1px solid rgba(102, 45, 145, 0.3)",
          borderRadius: "12px",
          px: 3,
          py: 2,
          mb: 3,
          maxWidth: 450,
          width: "100%",
        }}
      >
        <img
          src={emailOutlinedIcon}
          alt="Email"
          style={{
            width: 40,
            height: 40
          }}
        />

        <Typography
          sx={{
            fontFamily: "Montserrat, sans-serif",
            fontWeight: 500,
            fontStyle: "normal",
            fontSize: "0.75rem",
            lineHeight: "1.313rem",
            letterSpacing: "0%",
            color: "#7B41C3",
          }}
        >
          {t("inviteUsers.self_invite_blocked_hint")}
        </Typography>
      </Box>

      <Stack
        direction={{
          xs: "column",
          sm: "row"
        }}
        spacing={2}
        sx={{
          mt: 2,
          width: "100%",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <RoundedButton
          onClick={onGenerateNewLink}
          text={t("inviteUsers.generate_new_link")}
          sx={{
            background: "transparent",
            color: "#662D91",
            border: "2px solid #662D91",
            minWidth: 200,
            borderRadius: "20px",
            fontFamily: "Montserrat, sans-serif",
            fontWeight: 500,
            fontSize: "0.938rem",
            lineHeight: "1.054rem",
            textTransform: "uppercase",
            boxShadow: "none",
            "&:hover": { background: "rgba(102,45,145,0.05)", boxShadow: "none" },
          }}
        />
        <RoundedButton
          onClick={redirectToDashboard}
          text={t("inviteUsers.return_to_dashboard")}
          sx={{
            background: "transparent",
            color: "#662D91",
            border: "2px solid #662D91",
            minWidth: 200,
            borderRadius: "20px",
            fontFamily: "Montserrat, sans-serif",
            fontWeight: 500,
            fontSize: "0.938rem",
            lineHeight: "1.054rem",
            textTransform: "uppercase",
            boxShadow: "none",
            "&:hover": { background: "rgba(102,45,145,0.05)", boxShadow: "none" },
          }}
        />
      </Stack>
    </Box>
  );
};

export default SelfInviteBlockedView;
